module.exports = __webpack_public_path__ + "assets/fonts/FWDCircularVietWeb-Medium.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fwd/fonts/FWDCircularVietWeb-Medium.woff
 ** module id = 1099
 ** module chunks = 0
 **/